import { RiskAssessmentResultControlType } from '@risksmart-app/domain/src/types/consts/risk-assessment-result-control-type';
import type { Ref } from 'react';

import type { WidgetRef } from '../../types';
import { RiskBubbleChart } from './RiskBubbleChart';

export const ControlledRiskBubbleChart = (
  _props: unknown,
  ref: Ref<WidgetRef>
) => {
  return (
    <RiskBubbleChart
      ref={ref}
      controlType={RiskAssessmentResultControlType.Controlled}
    />
  );
};
